import { useCallback, useMemo } from 'react'
import axios from 'axios'
import { useMutation } from '@tanstack/react-query'

import config from '../../config'

import {
  IGetPostRequest,
  IUseAddMutation,
  IAddFn,
  ISafetyCaseAction,
  ISafetyCaseActionUpsert,
} from '../../interfaces'

const getCreateSafetyCaseActionMutationRequest: IGetPostRequest = () => ({
  method: 'post',
  url: `${config.baseUrl}/sms/SafetyCaseActions`,
})

const useCreateSafetyCaseActionMutation: IUseAddMutation<ISafetyCaseAction, ISafetyCaseActionUpsert> = (
  params,
  options = {},
) => {
  const request = useMemo(() => getCreateSafetyCaseActionMutationRequest(params), [params])

  const createSafetyCaseAction: IAddFn<ISafetyCaseActionUpsert, ISafetyCaseAction> = useCallback(
    async data => axios({ ...request, data }).then(res => res.data),
    [request],
  )

  const response = useMutation<ISafetyCaseAction, Error, ISafetyCaseActionUpsert>({
    mutationFn: createSafetyCaseAction,
    ...options,
  })

  return response
}

export default useCreateSafetyCaseActionMutation
